import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private collapsed$ = new BehaviorSubject<boolean>(false);
  private orgSelectVisibility$ = new BehaviorSubject<boolean>(false);
  private projectSelectVisibility$ = new BehaviorSubject<boolean>(false);

  constructor() { }

  getSideNavState(): Observable<boolean> {
    return this.collapsed$.asObservable();
  }

  collapseSideNav(): void {
    this.collapsed$.next(true);
  }

  expandSideNav(): void {
    this.collapsed$.next(false);
  }

  toggleSideNav(): void {
    this.collapsed$.next(!this.collapsed$.value);
  }

  getOrgSelectVisibility(): Observable<boolean> {
    return this.orgSelectVisibility$.asObservable();
  }

  showOrgSelect(): void {
    this.orgSelectVisibility$.next(true);
  }

  hideOrgSelect(): void {
    this.orgSelectVisibility$.next(false);
  }

  getProjectelectVisibility(): Observable<boolean> {
    return this.projectSelectVisibility$.asObservable();
  }

  showProjectSelect(): void {
    this.projectSelectVisibility$.next(true);
  }

  hideProjectSelect(): void {
    this.projectSelectVisibility$.next(false);
  }
}
